
export const WIDTH = 128;
export const HEIGHT = 96;
export const ZOOM = 10;

export const PALETTES = [
  ['#00FF00', '#FF0000', '#FFFF00', '#0000FF'], // Set 1: Green, Red, Yellow, Blue
  ['#F5F5F5', '#00FFFF', '#FF00FF', '#FFA500']  // Set 2: Buff, Cyan, Magenta, Orange
];

export const PALETTE_NAMES_SET = [
  ['GREEN', 'RED', 'YELLOW', 'BLUE'],
  ['BUFF', 'CYAN', 'MAGENTA', 'ORANGE']
];
